<template>
  <v-card class="mt-5">
    <AppVCardTitleWithButton label="Trou d’homme, détecteur de fuite, jaugeages électronique et manuel"
                             image_url="/img/implementedForms/62b97ed722d02/controlManhole.png"/>
    <v-card-text v-if="showNoRecentManualMeasureWarning" class="pt-0 pb-0">
      <v-alert type="error" text shaped icon="mdi-alert-outline">
        Pas de relevé manuel récent sur l'équipement. Veuillez repasser l'aimant sur le capteur.
      </v-alert>
    </v-card-text>
    <AppLastBatteryValue :battery="battery" :timestamp="timestamp"/>
    <v-card-text v-if="dtdHistory.length" class="pt-3 pb-4">
      <h3 class="mb-2 d-flex align-center">
        Derniers relevés
        <v-progress-circular indeterminate size="16" width="2" color="primary" class="ml-2"/>
      </h3>
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Date relevé</th>
            <th>Niveau liquide (mm)</th>
            <th>Déclencheur</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in dtdHistory" :key="entry.id">
            <td>{{ formatDate(entry.date_releve) }}</td>
            <td>{{ entry.liquid_level }}</td>
            <td>{{ triggerLabel(entry.declencheur) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-text class="pb-4 pl-4 pr-4">
      <h3>Rappel</h3>
      <div  class="font-16 ml-4 mt-2">
        <div>Capacité cuve : {{this.assetCapacity}}</div>
        <div>numéro device : {{this.deviceNumber}}</div>
        <div>reference cuve : {{this.assetReference}}</div>
      </div>
    </v-card-text>
    <AppCheckbox v-model="value.changeBattery" label="Changement de la batterie du capteur"/>
    <v-card-text v-if="value.changeBattery">
      <v-checkbox v-model="value.activateSensorAfterChange" class="mb-n4 mt-n4"
                  label="Activer le capteur après changement de piles *" :rules="[v => !(value.changeBattery && !v)]"/>
    </v-card-text>
    <v-card-text>
      <v-row class="pb-4 pl-4 pr-4" justify="space-between" align="center">
        <div class="font-16">
          Nombre de relevés par jour: <span class="font-weight-bold">{{ value.device.nb_releve_par_jour }}</span>
        </div>
      </v-row>
    </v-card-text>
    <AppCheckbox v-if="value.device.nb_releve_par_jour === 1" v-model="value.changeDevice"
                 label="Remplacer le capteur par un capteur 6 RJ *" :required="true"/>
    <AppGaugingCheck v-model="value.lastMeasureCheck" :expected-measure="expectedMeasure" :timestamp="timestamp" :declencheur="declencheur"/>
    <v-card-text class="pb-8">
      <v-row align="center" justify="space-between" class="px-4">
        <div class="font-16">Paramétrage offset : <span class="font-weight-bold">{{ offset }} mm</span></div>
        <v-btn height="40px" color="primary" @click="newOffset = offset; offsetDialog = true">Mettre à jour l'offset</v-btn>
      </v-row>
    </v-card-text>

    <v-dialog v-model="offsetDialog" max-width="400">
      <v-card>
        <v-card-title>Mettre à jour l'offset</v-card-title>
        <v-card-text>
          <v-text-field
            v-model.number="newOffset"
            label="Nouvel offset (mm)"
            type="number"
            filled
            autofocus
            :rules="[v => (v !== 0 && v !== null && v !== '') || 'L\'offset ne peut pas être 0']"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="offsetDialog = false" :disabled="offsetLoading">Annuler</v-btn>
          <v-btn color="primary" @click="submitOffsetUpdate" :loading="offsetLoading" :disabled="!newOffset">Mettre à jour</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text class="pt-0 pb-0">
      <v-textarea v-model="value.localDisplayState.comment" placeholder="Commentaire" rows="1" auto-grow filled></v-textarea>
      <v-row class="pb-4 pl-4 pr-4" justify="space-between" align="center">
        <div v-if="value.localDisplayState.checked === 'true'" class="font-16">
          Photo du capteur *
        </div>
        <div v-else class="font-16">
          Débrancher l’alimentation de l’afficheur et prendre une photo de l’afficheur débranché*
        </div>
      </v-row>
      <AppImageInput v-model="image" placeholder="Ajouter une image" :rules="[v => !!v && v.length === 1]"/>
    </v-card-text>

    <v-card-text v-if="value.controlOfTheLeakDetector">
      <AppRadioYesNo v-model="value.leakDetectorCompliant" label="Niveau: " yes_label="Conforme"
                     no_label="Non conforme"/>
    </v-card-text>
    <v-card-text v-if="value.controlOfTheLeakDetector && value.leakDetectorCompliant == 'false'" class="mt-n8 pb-0">
      <AppRadioYesNo v-model="value.needsComplementAntifreeze" label="Besoin complément du produit Antigel"/>
    </v-card-text>
    <v-card-text
        v-if="value.controlOfTheLeakDetector && value.leakDetectorCompliant == 'false' && value.needsComplementAntifreeze == 'true'"
        class="ml-4">
      <v-row class="pl-3 pr-3 mb-n4 mr-4" justify="space-between">
        <p class="mb-0">Quantité réassort estimée</p>
        <v-radio-group v-model="value.antifreezeVolume" row class="ma-0 mt-n1">
          <v-radio label="1L" value="1"></v-radio>
          <v-radio label="2L" value="2"></v-radio>
          <v-radio label="5L" value="5"></v-radio>
        </v-radio-group>
      </v-row>
    </v-card-text>
    <AppCheckboxWithConformityForm v-model="value.controlOfWeldsAndJoints"
                                   label="Trou d’homme, contrôle des soudures et joints"/>
  </v-card>
</template>

<script>
import moment from "moment";
import AppCheckbox from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/Checkbox";
import AppCheckboxWithConformityForm
  from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/CheckboxWithConformityForm";
import AppRadioYesNo from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/RadioYesNo";
import AppVCardTitleWithButton
  from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/VCardTitleWithButton";
import AppLastBatteryValue
  from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/LastBatteryValue";
import AppGaugingCheck from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/GaugingCheck";
import AssetRepository from "@/repositories/AssetRepository";
import AppImageInput from "@/components/App/ImageInput";

import { triggerLabel } from '../constants/triggers'

export default {
  name: "Manhole",
  components: {
    AppVCardTitleWithButton,
    AppCheckbox,
    AppCheckboxWithConformityForm,
    AppRadioYesNo,
    AppLastBatteryValue,
    AppGaugingCheck,
    AppImageInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      battery: -1,
      expectedMeasure: 0,
      timestamp: 0,
      declencheur: null,
      dateLastManualInsert: null,
      image: null,
      assetCapacity : null,
      assetReference : null,
      deviceNumber : null,
      offset: null,
      initialOffset: null,
      dtdHistory: [],
      offsetDialog: false,
      newOffset: null,
      offsetLoading: false,
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    triggerLabel,
    async submitOffsetUpdate() {
      this.offsetLoading = true
      try {
        await AssetRepository.updateOffset(this.newOffset)
        this.offset = this.newOffset
        this.offsetDialog = false
        this.$store.dispatch("snackbar/show", {
          snackbar_text: "Offset mis à jour avec succès",
          snackbar_type: "success",
        })
        this.pollSensorData()
      } catch {
        this.$store.dispatch("snackbar/show", {
          snackbar_text: "Erreur lors de la mise à jour de l'offset",
          snackbar_type: "error",
        })
      } finally {
        this.offsetLoading = false
      }
    },
    pollSensorData() {
      Promise.all([
        AssetRepository.getLastAssetDtd(),
        AssetRepository.getInstallationCheck(),
      ]).then(([dtdResponse, installationResponse]) => {
        const d = dtdResponse.data.data
        if (d && d.id_devices_traited_data) {
          const alreadyPresent = this.dtdHistory.some(e => e.id === d.id_devices_traited_data)
          if (!alreadyPresent) {
            this.dtdHistory.unshift({
              id: d.id_devices_traited_data,
              liquid_level: d.hauteur_liquide,
              declencheur: d.declencheur,
              date_releve: d.date_releve,
            })
            if (this.dtdHistory.length > 5) this.dtdHistory.pop()
          }
        }

        this.battery = installationResponse.data.data.batterie;
        this.expectedMeasure = Math.floor(installationResponse.data.data.hauteur_liquide / 10);
        this.timestamp = moment(installationResponse.data.data.date_releve).unix();
        this.declencheur = installationResponse.data.data.declencheur ?? null;
        this.dateLastManualInsert = installationResponse.data.data.date_releve ?? null;

        this.$emit("input", {...this.value, lastBattery: this.battery, lastEmisionDate: this.timestamp, dtdHistory: this.dtdHistory, offset: this.offset, initialOffset: this.initialOffset});
      })
    },
  },
  computed: {
    showNoRecentManualMeasureWarning() {
      return !this.dateLastManualInsert || moment().diff(moment(this.dateLastManualInsert), 'hours', true) >= 1;
    },
  },
  async mounted() {
    // Restore local image from draft if present
    if (this.value.localDisplayState.files) {
      this.image = this.value.localDisplayState.files
    }

    AssetRepository.getAssetDetail().then(response => {
      this.assetReference = response.data.data.internal_reference
      this.deviceNumber = response.data.data.device_number
      this.assetCapacity = response.data.data.capacity
      this.offset = response.data.data.offset
      this.initialOffset = response.data.data.offset
      this.dateLastManualInsert = response.data.data.date_last_manual_insert ?? null
    })

    this.pollSensorData()
    this._sensorDataInterval = setInterval(this.pollSensorData, 10000)
  },
  beforeDestroy() {
    clearInterval(this._sensorDataInterval)
  },
  watch: {
    image(newValue) {
      this.value.localDisplayState.files = newValue;
    },
  },
};
</script>
